const namespace = "unregistrationMessage";

export const OK = `${namespace}.ok`;
export const UNREGISTER_CASH = `${namespace}.unregisterCash`;
export const UNREGISTER_TICKET = `${namespace}.unregisterTicket`;
export const UNREGISTER_TOURNAMENT = `${namespace}.unregisterTournament`;
export const UNREGISTER_FREEROLL = `${namespace}.unregisterFreeroll`;
export const UNREGISTER_CONFIRMATION = `${namespace}.unregisterConfirmation`;
export const NOTIFICATION = `${namespace}.notification`;
